export const logoutStatusCodes = [
  'MISSING_ACCESS_TOKEN_ERROR',
  'INVALID_ACCESS_TOKEN_ERROR',
  'INCOMPATIBLE_ACCESS_TOKEN_ERROR',
  'ACCESS_TOKEN_EXPIRED_ERROR',
];
